<script setup lang="ts">
import { ref, onMounted } from "vue";
import { aggregateFunctionOptions, Field, ReportDesign, Table } from "../../../types/report";
import AddField from "./AddField.vue";
import IconComponent from "../../ui/common/IconComponent.vue";
//import Buttons from "../../ui/form/Buttons.vue";
import SearchSelect from "../../ui/form/SearchSelect.vue";
import { useFormValidation } from "../../../composables/useFormValidation";
import { required } from "../../../utils/validation";
import NumberInput from "../../ui/form/NumberInput.vue";
import CheckInput from "../../ui/form/CheckInput.vue";
import RadioInput from "../../ui/form/RadioInput.vue";
import { mapSqlTypeToVueType } from "../../../types/mapSqlTypeToVueType";
import { api } from "../../../api/Api";
import Toast from "../../../services/Toast";
import Buttons from "../../ui/form/Buttons.vue";
//import RadioCheckInput from "../../ui/form/RadioCheckInput.vue";

const props = defineProps<{
  report: ReportDesign;
  data?: any;
  mode?: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
}>();

const emit = defineEmits<{
  (e: "addField", data: Field, pivotFieldId: string, aggregateFieldId: string, aggregateFunction: string, width: number, 
    dbTable: string, dbField: string, sortField: string, sortOrder: 'asc' | 'desc', dynamicFields: boolean
  ): void;
}>();

//const expandedTables = ref<string[]>([]);
const showFieldProperties = ref(false);
const selectedField = ref<Field>();
const fieldToAdd = ref<Field>();

/*const toggleTable = (tableKey: string) => {
  const index = expandedTables.value.indexOf(tableKey);
  if (index === -1) {
    expandedTables.value.push(tableKey);
  } else {
    expandedTables.value.splice(index, 1);
  }
};

const isTableExpanded = (tableKey: string) => {
  return expandedTables.value.includes(tableKey);
};
*/
const selectField = (field: any) => {
  emit("addField", field, fields.value.pivotFieldId.value, fields.value.aggregateFieldId.value, fields.value.aggregateFunction.value, fields.value.width.value, 
    fields.value.dbTable.value, fields.value.dbField.value, fields.value.sortField.value, fields.value.sortOrder.value, fields.value.dynamicFields.value);
};

const {
  fields,
  //formData,
  setFieldRules,
  //validateForm,
  //resetForm,
  //setFormData,
} = useFormValidation({
    pivotFieldId: props.data?.pivotFieldId || null,
    aggregateFieldId: props.data?.aggregateFieldId || null,
    aggregateFunction: props.data?.aggregateFunction || undefined,
    fields: props.data?.fields || [],
    dynamicFields: props.data?.dynamicFields || false,
    dbTable: props.data?.dbTable || '',
    dbField: props.data?.dbField || '',
    sortField: props.data?.sortField || '',
    width: props.data?.width || 100,
    sortOrder: props.data?.sortOrder || 'asc',
});

setFieldRules("pivotFieldId", [required("Pivot Field is required")]);
setFieldRules("aggregateFieldId", [required("Aggregate Field is required")]);
setFieldRules("aggregateFunction", [required("Aggregate Function is required")]);
setFieldRules("fields", [required("Select at least one field")]);

setFieldRules("dbTable", fields.value.dynamicFields.value ? [required("Select Table for Dynamic fields")] : []);
setFieldRules("dbField", fields.value.dynamicFields.value ? [required("Select Display Field for Dynamic Fields")] : []);
setFieldRules("sortField", fields.value.dynamicFields.value ? [required("Select Sort field for Dynamic Fields")] : []);
setFieldRules("sortOrder", fields.value.dynamicFields.value ? [required("Select Sort Order for Dynamic Fields")] : []);


const addFieldToReport = (field: Field) => {
  field.manual = true;
  props.report.pivot?.fields.push(field)
  //emit("addField", field);
  showFieldProperties.value = false;
};
/*const addFieldToReport = () => {
  if (props.report && selectedField.value) {
    props.report.pivot?.fields.push({
      tableField: selectedField.value.tableField,
      alias: selectedField.value.alias,
      caption: selectedField.value.caption,
      visible: selectedField.value.visible,
      align: selectedField.value.align
    })
    showFieldProperties.value = false
    selectedField.value = null
  }
}

const removeField = (index: number) => {
  if (props.report.value) {
    props.report.value.fields.splice(index, 1)
  }
}*/

const moveFieldUp = (index: number) => {
  if (index > 0) {
    const field = props.report.pivot?.fields[index];
    if (field) {
      props.report.pivot?.fields.splice(index, 1);
      props.report.pivot?.fields.splice(index - 1, 0, field);
      props.report.pivot?.fields.forEach((f, i) => {
        f.sort_order = i;
      });
    }
  }
};

const moveFieldDown = (index: number) => {
  if (
    props.report.pivot?.fields &&
    index < props.report.pivot.fields.length - 1
  ) {
    const field = props.report.pivot.fields[index];
    props.report.pivot.fields.splice(index, 1);
    props.report.pivot.fields.splice(index + 1, 0, field);
    props.report.pivot.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const removeField = (index: number) => {
  if (
    props.report.fields &&
    props.report.pivot?.fields &&
    index >= 0 &&
    index < props.report.pivot.fields.length
  ) {
    props.report.pivot.fields.splice(index, 1);
    props.report.pivot.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const dragStart = (index: number) => {
  draggingIndex.value = index;
};
const draggingIndex = ref<number | null>(null);
const dragOver = (index: number) => {
  if (draggingIndex.value !== null && draggingIndex.value !== index) {
    const field = props.report.pivot?.fields[draggingIndex.value];
    if (field) {
      props.report.pivot?.fields.splice(draggingIndex.value, 1);
      props.report.pivot?.fields.splice(index, 0, field);
      draggingIndex.value = index;
      props.report.pivot?.fields.forEach((f, i) => {
        f.sort_order = i;
      });
    }
  }
};
const drop = (_index: number) => {
  draggingIndex.value = null;
};

onMounted(() => {
  console.log("StepField component mounted");
  console.log(props.report);
});

const tableFields = ref<Field[]>([]);

const getFields = async (table: Table) => {
  try {
    const response = await api.post("/clients/reports/fields", {
      table: table.id,
    });
    if (response.success == true) {
      let data = response.data;
      data.forEach((field: { field_type: string; }) => {
        field.field_type = mapSqlTypeToVueType(field.field_type);
      });
      tableFields.value = data;
    }
  } catch (error) {
    Toast.show(String(error) || "Failed to fetch Source Fields", "error");
    return [];
  }
};

const updatePivot = () => {
  emit("addField", {} as Field, fields.value.pivotFieldId.value, fields.value.aggregateFieldId.value, fields.value.aggregateFunction.value, fields.value.width.value, 
    fields.value.dbTable.value, fields.value.dbField.value, fields.value.sortField.value, fields.value.sortOrder.value, fields.value.dynamicFields.value);
};

const addPivottedField = () => {
  showFieldProperties.value = true;
  fieldToAdd.value = {
    id: 'field_' + Math.random().toString(36).substring(2, 15),
    tableId: '',
    tableName: '',
    tableAlias: '',
    name: '',
    alias: '',
    caption: '',
    visible: true,
    aggregateFunction: undefined,
    decimals: 0,
    align: 'Right',
    type: 'number',
    manual: true,
    width: 100,
    raw: true,
    rawQuery: "",
  };
  showFieldProperties.value = true
};

/*const availableFields = computed(() =>
  props.report.pivot?.fields.filter(
    (field) => !props.report.pivot?.fields.some((f) => f === field)
  )
);*/
</script>

<template>
  <div class="fields-section section">
    <div
      class="section-header"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <div id="step-name" style="display: flex; align-items: center">
        <div class="step-indicator">Step 4</div>
        <h2 style="margin-left: 0.75rem">Pivoting</h2>
      </div>
      <div id="add-raw-field">
      <Buttons
        caption="Add Pivotted Fields"
        icon="Plus" 
        @click="addPivottedField"
      />
      </div>
    </div>

    <div class="fields-container">
      <div class="available-fields">
        <h3>Available Fields</h3>
        <div class="field-tree">
          <div class="field-list">
            <div v-if="report.fields.length === 0" class="empty-state">
              <p>No fields availeble.</p>
            </div>
            <template v-for="field in report.fields" :key="field.name">
              <div
                v-if="
                  !report.pivot?.fields.some((f) => f.caption === field.caption)
                "
                class="field-item"
                @click="selectField(field)"
              >
                <IconComponent name="BetweenHorizontalStart" />
                <span>{{ field.caption }}</span>
              </div>
            </template>
          </div>

          <div></div>
        </div>
      </div>

      <div class="selected-fields">
        <h3>Selected Fields</h3>
        <div class="fields-list">
          <div v-if="report.pivot?.fields.length === 0" class="empty-state">
            <p>No fields selected.</p>
          </div>
          <table
            class="divide-y divide-gray-200 dark:divide-gray-700 w-full"
            style="width: 100%; border-collapse: collapse"
            v-else
          >
            <thead>
              <tr
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                <th style="text-align: left; padding: 0.5rem">Caption</th>
                <th style="text-align: left; padding: 0.5rem">Type</th>
                <th style="text-align: right; padding: 0.5rem">Order</th>
                <th
                  style="text-align: center; padding: 0.5rem"
                  class="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider sticky right-0 bg-gray-50 dark:bg-gray-800 shadow-l"
                >
                  ...
                </th>
              </tr>
            </thead>
            <tbody
              class="bg-white text-sm py-4 dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
            >
              <tr
                v-for="(field, index) in report.pivot?.fields"
                :key="field.id"
                style="border-bottom: 1px solid #e9ecef"
                draggable="true"
                @dragstart="dragStart(index)"
                @dragover.prevent="dragOver(index)"
                @drop="drop(index)"
                :class="{ dragging: draggingIndex === index }"
                class="hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                <td style="padding: 0.5rem; display: flex; align-items: center">
                  <IconComponent
                    name="GripVertical"
                    style="margin-right: 0.5rem; cursor: grab"
                  />
                  {{ field.caption }}
                </td>
                <td style="padding: 0.5rem; color: #888">{{ field.type }}</td>
                <td style="padding: 0.5rem; text-align: right">
                  {{ field.sort_order }}
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  <button
                    :disabled="index == 0"
                    @click="moveFieldUp(index)"
                    class="mr-2"
                    title="Move Up"
                    :style="{ color: index == 0 ? 'white' : '' }"
                  >
                    <IconComponent name="CircleArrowUp" />
                  </button>
                  <button
                    :disabled="
                      !report.pivot?.fields ||
                      index == report.pivot.fields.length - 1
                    "
                    @click="moveFieldDown(index)"
                    class="mr-2"
                    title="Move Down"
                    :style="{
                      color:
                        index == (report.pivot?.fields?.length ?? 0) - 1
                          ? 'white'
                          : '',
                    }"
                  >
                    <IconComponent name="CircleArrowDown" />
                  </button>
                  <button
                    id="table-action-remove-table"
                    @click="removeField(index)"
                    class="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-600"
                    title="Delete Table"
                  >
                    <IconComponent name="Trash2" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="available-fields">
        <h3>Pivot Settings</h3>
        <div class="field-tree">
          <div class="field-list">
            <div class="form-group">
              <SearchSelect
                v-model="fields.pivotFieldId.value"
                @select="updatePivot"
                :options="report.fields.map(f => ({
                  id: f.caption,
                  name: f.caption || f.name,
                  type: f.type
                })).filter(f => f.type !== 'number' && f.name.toLocaleLowerCase() !== 'id' && !f.name.toLocaleLowerCase().includes('_id'))"
                label="Pivot Field" />
            </div>
            <div class="form-group">
              <SearchSelect
                v-model="fields.aggregateFieldId.value"
                @select="updatePivot"
                :options="report.fields.map(f => ({
                  id: f.caption,
                  name: f.caption || f.name,
                  type: f.type
                })).filter(f => f.type === 'number' && f.name.toLocaleLowerCase() !== 'id' && !f.name.toLocaleLowerCase().includes('_id'))"
                label="Aggregate Field" />
            </div>
            <div class="form-group">
              <SearchSelect
                v-model="fields.aggregateFunction.value"
                @select="updatePivot"
                :options="aggregateFunctionOptions"
                label="Aggregate Function" />
            </div>
            <div class="form-group">
              <NumberInput
                v-model="fields.width.value"
                label="Column Width" />
            </div>
            <div class="form-group">
              <CheckInput
                v-model="fields.dynamicFields.value"
                label="Use Dynamic Fields" />
            </div>
          </div>
          <div></div>
        </div>
      </div>

      <div class="available-fields" v-if="fields.dynamicFields.value">
        <h3>Dynamic Field Settings</h3>
        <div class="field-tree">
          <div class="field-list">
            <div class="form-group">
              <SearchSelect 
              label="Table"
                v-model="fields.dbTable.value"
                @select="getFields"
                custom-url="reports/tables"
                placeholder="Select Table" />
            </div>
            <div class="form-group">
            <SearchSelect 
              label="Display Field"
              @select="updatePivot"
                v-model="fields.dbField.value"
                :options="tableFields"/>
            </div>
            <div class="form-group">
            <SearchSelect 
              label="Sort Field"
              @select="updatePivot"
                v-model="fields.sortField.value"
                :options="tableFields" />
            </div>
            <div class="form-group">
            <RadioInput 
              v-model="fields.sortOrder.value"
              @update="updatePivot"
              :options="[
                { name: 'Ascending', id: 'asc' },
                { name: 'Descending', id: 'desc' }
              ]"
              optionLabel="name"
              name="sortOrder"
              label="Sort Order" />
            </div>
</div>
          <div></div>
        </div>
      </div>

    </div>
  </div>
  <AddField
    v-if="showFieldProperties"
    :report="report"
    :pivot="true"
    :field="fieldToAdd"
    :mode="selectedField ? 'edit' : 'create'"
    :title="
      selectedField
        ? 'Edit' + selectedField.name + '(' + selectedField.alias + ')'
        : 'Add New Field'
    "
    :data="selectedField"
    @close="showFieldProperties = false"
    @addField="addFieldToReport"
  />
</template>
<style scoped>
.fields-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.available-fields,
.selected-fields {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
}

.available-fields h3,
.selected-fields h3 {
  font-size: 1rem;
  margin: 0 0 1rem 0;
  color: #495057;
}

.field-tree {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.table-node {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: white;
  cursor: pointer;
  user-select: none;
}

.table-header:hover {
  background-color: #f8f9fa;
}

.field-list {
  padding: 0.5rem;
  margin-left: 1.2rem;
  background-color: white;
}

.field-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
}

.field-item:hover {
  background-color: #f8f9fa;
}

.field-item i {
  color: #6c757d;
  font-size: 0.875rem;
}

.empty-state {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  color: #6c757d;
}
</style>
